import { render, staticRenderFns } from "./feedback.vue?vue&type=template&id=50987674&scoped=true"
import script from "./feedback.vue?vue&type=script&lang=ts"
export * from "./feedback.vue?vue&type=script&lang=ts"
import style0 from "./feedback.vue?vue&type=style&index=0&id=50987674&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50987674",
  null
  
)

export default component.exports